import { createEntityAdapter } from "@reduxjs/toolkit";

import { createReduxStore } from "./redux_store";

const adapter = createEntityAdapter({
  sortComparer: (a, b) => new Date(a.date) - new Date(b.date),
});

const ClassStore = createReduxStore({
  name: "class",
  adapter,
  customSelectors: {
    selectNextClasses: (selectors, state, sectionId) => {
      if (sectionId) {
        return selectors
          .selectAll(state)
          .filter((klass) => klass.next && klass.section_id === sectionId);
      }
      return selectors.selectAll(state).filter((klass) => klass.next);
    },
    selectPastClasses: (selectors, state, sectionId) => {
      return selectors
        .selectAll(state)
        .filter((klass) => klass.past && klass.section_id === sectionId);
    },
  },
});

export { ClassStore };
